<ion-header>
  <ion-toolbar>
      <ion-button slot="end" style="--background: var(--ion-color-primary);" fill="solid" (click)="cancel()">
        <ion-icon slot="start" name="close-circle-outline"></ion-icon>
        {{ 'General.Cancel' | translate }}
      </ion-button>
    <ion-title class="cart-title"></ion-title>
  </ion-toolbar>
</ion-header> 


<ion-content>
  <ion-grid>
    <ion-card-content>   
  <app-closedsub-modal [orderType]="orderType" [fromDesktop]="fromDesktop"></app-closedsub-modal>
</ion-card-content>
</ion-grid>
</ion-content>

